import PavilionContainer from "components/pavilions/PavilionContainer";

export default function PavilionContainerPage() {
  return <PavilionContainer />;
}
